import {
  ArticleType,
  CreatedSiteStatus,
  CustomerStatus,
  CustomerTaskStatus,
  FindBySource,
  ProspectionType,
  UserRole,
} from "../__generated__/globalTypes";

const ARTICLE_TYPE_LABELS: Record<ArticleType, string> = {
  [ArticleType.Long]: "Long",
  [ArticleType.Court]: "Court",
};

const CREATED_SITE_STATUS_LABELS: Record<CreatedSiteStatus, string> = {
  [CreatedSiteStatus.Creating]: "En cours",
  [CreatedSiteStatus.Done]: "Terminé",
  [CreatedSiteStatus.Error]: "Erreur",
};

const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  [CustomerStatus.Prospect]: "Prospect",
  [CustomerStatus.Converti]: "Converti",
};

const FIND_BY_SOURCE_LABELS: Record<FindBySource, string> = {
  [FindBySource.Google]: "Google",
  [FindBySource.PagesJaunes]: "Pages Jaunes",
  [FindBySource.Autre]: "Autre",
};

const PROSPECTION_TYPE_LABELS: Record<ProspectionType, string> = {
  [ProspectionType.Phone]: "Téléphone",
  [ProspectionType.Email]: "Email",
  [ProspectionType.Sms]: "SMS",
};

const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.Admin]: "Administrateur",
  [UserRole.Client]: "Client",
  [UserRole.Employee]: "Employé",
};

const CUSTOMER_TASK_STATUS_LABELS: Record<CustomerTaskStatus, string> = {
  [CustomerTaskStatus.Todo]: "À faire",
  [CustomerTaskStatus.InProgress]: "En cours",
  [CustomerTaskStatus.Done]: "Terminé",
};

export const CUSTOMER_TASK_PRIORITY_LABELS: Record<number, { label: string; color: string }> = {
  0: { label: "Critique", color: "bg-red-100 text-red-700" },
  1: { label: "Important", color: "bg-orange-100 text-orange-700" },
  2: { label: "Normal", color: "bg-blue-100 text-blue-700" },
  3: { label: "Faible", color: "bg-gray-100 text-gray-600" },
};

export const customerTaskPriorityInfo = (priority?: number | null) =>
  CUSTOMER_TASK_PRIORITY_LABELS[priority ?? 1] ?? { label: `${priority}`, color: "bg-gray-100 text-gray-600" };

export const articleTypeLabel = (value?: ArticleType | string | null) =>
  (value && ARTICLE_TYPE_LABELS[value as ArticleType]) ?? value ?? "";

export const createdSiteStatusLabel = (value?: CreatedSiteStatus | string | null) =>
  (value && CREATED_SITE_STATUS_LABELS[value as CreatedSiteStatus]) ?? value ?? "";

export const customerStatusLabel = (value?: CustomerStatus | string | null) =>
  (value && CUSTOMER_STATUS_LABELS[value as CustomerStatus]) ?? value ?? "";

export const findBySourceLabel = (value?: FindBySource | string | null) =>
  (value && FIND_BY_SOURCE_LABELS[value as FindBySource]) ?? value ?? "";

export const prospectionTypeLabel = (value?: ProspectionType | string | null) =>
  (value && PROSPECTION_TYPE_LABELS[value as ProspectionType]) ?? value ?? "";

export const userRoleLabel = (value?: UserRole | string | null) =>
  (value && USER_ROLE_LABELS[value as UserRole]) ?? value ?? "";

export const customerTaskStatusLabel = (value?: CustomerTaskStatus | string | null) =>
  (value && CUSTOMER_TASK_STATUS_LABELS[value as CustomerTaskStatus]) ?? value ?? "";
